import 'vite/modulepreload-polyfill';
import gsap from 'gsap';
import Swiper from 'swiper';
import { createApp, onMounted, onUnmounted, ref, watch } from 'vue';

import { useViewportSize } from '~/composables/use-viewport-size';
import { BREAKPOINTS } from '~/composables/use-viewport-size';
import { ANIMATION_CONFIGS } from '~/constants/animations';

import { BaseSection } from './base-section';

/**
 * @type {import('swiper/types').SwiperOptions}
 */
const SWIPER_SETTINGS = {
  allowTouchMove: true,
  breakpoints: {
    [BREAKPOINTS.LG]: {
      allowTouchMove: false,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      slidesPerView: 5,
    },
    [BREAKPOINTS.MD]: {
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerView: 2.3,
    },
  },
  slidesOffsetAfter: 20,
  slidesOffsetBefore: 20,
  slidesPerView: 1.3,
  spaceBetween: 10,
};

export default class CollectionHeader extends BaseSection {
  constructor() {
    super('[data-section-type="collection-header"]');
  }

  init(instanceData) {
    const container = instanceData.container;

    createApp({
      name: 'CollectionHeaderSection',
      setup() {
        const carousel = ref(null);
        const { isXLarge } = useViewportSize();

        const fadeInCarousel = () => {
          const carouselElement = container.querySelector('[data-swiper-container]');
          if (carouselElement) {
            gsap.to(carouselElement, ANIMATION_CONFIGS.FADE_IN);
          }
        };

        onMounted(() => {
          carousel.value = new Swiper(
            container.querySelector('[data-swiper-container]'),
            SWIPER_SETTINGS,
          );
          fadeInCarousel();
        });

        watch(isXLarge, () => {
          if (carousel.value) {
            carousel.value.params.allowTouchMove = !isXLarge.value;
            carousel.value.update();
          }
        });

        onUnmounted(() => {
          carousel.value?.destroy();
          carousel.value = null;
        });

        return {};
      },
    }).mount(container);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionHeader();
});
